import script from "./NotifyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifyModal.vue?vue&type=script&setup=true&lang=js"

import "./NotifyModal.vue?vue&type=style&index=0&id=72f8f6da&scoped=true&lang=css"
/* custom blocks */
import block0 from "./NotifyModal.vue?vue&type=custom&index=0&blockType=spec&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f8f6da"]])

export default __exports__